<template>
    <div>
      <Nav />


      <Footer />
    </div>
  </template>

  <script>


  import Nav from "../components/Nav.vue"


  import { mapState } from 'vuex';

  export default {
    name: 'NotFound',
    components: {
      Nav
    },
    computed: {
      ...mapState({
        count: state => state.count
      })
    },
    methods: {
      increment() {
        this.$store.dispatch('increment');
      }
    },
    created() {
      console.log('Home component created, count:', this.count);
    },
    updated() {
      console.log('Home component updated, count:', this.count);
    }
  };
  </script>
